import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import VueMask from 'v-mask';
import VueApexCharts from 'vue-apexcharts';
import i18n from '@/plugins/i18n';
import moment from 'moment'
import config from "@/config/config";
// moment.locale('sv')
require('moment-precise-range-plugin');
Vue.use(VueMask);
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false
Vue.config.devtools = false
window.moment = moment;
window.loggg = function (data) {
  console.log(JSON.parse(JSON.stringify(data)))
}
// window.Event = new Vue();

config.init().then(() => {
  new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');
});
